import keyMirror from 'react-utils/keyMirror';
export const PropertyObjectTypes = keyMirror({
  CONTACT: null,
  COMPANY: null,
  DEAL: null,
  TICKET: null,
  SHIPMENT: null,
  CUSTOM: null,
  FEEDBACK_SUBMISSION: null,
  PRODUCT: null,
  UNKNOWN: null
});
export const PropertyObjectTypesIds = {
  [PropertyObjectTypes.CONTACT]: '0-1',
  [PropertyObjectTypes.TICKET]: '0-5',
  [PropertyObjectTypes.COMPANY]: '0-2',
  [PropertyObjectTypes.DEAL]: '0-3',
  [PropertyObjectTypes.SHIPMENT]: '0-x',
  [PropertyObjectTypes.PRODUCT]: '0-7',
  [PropertyObjectTypes.CUSTOM]: '0-x',
  [PropertyObjectTypes.FEEDBACK_SUBMISSION]: '0-1'
};
export const contactObjectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.CONTACT];
export const ticketObjectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.TICKET];
export const companyObjectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.COMPANY];
export const dealObjectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.DEAL];
export const customObjectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.CUSTOM];